import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { MutualModule } from '@shared/mutual/mutual.module';
import { BrokerMessagesChatComponent } from './components';

@NgModule({
  declarations: [BrokerMessagesChatComponent],
  imports: [CommonModule, PipesSharedModule, MutualModule],
  exports: [BrokerMessagesChatComponent],
})
export class BrokerMessagesModule {}
